import { useEffect, useRef } from 'react';
import { channel } from '../../utils/broadcast';
import { useScreenStore } from '../../stores/useScreenStore';
import { useOverlayStore } from '../../stores/useOverlayStore';
import { useOccurrenceModalStore } from '../../stores/useOccurrenceModalStore';
import { useCalendarModalStore } from '../../stores/useCalendarModalStore';
import { useDeleteTripModalStore } from '../../stores/useDeleteTripModalStore';
import { useVehicleConflictStore } from '../../stores/useVehicleConflictStore';

export function useOverlay() {

    //move
    const moveReceive = useRef(false);
    const preferredScreen = useOverlayStore(state => state.preferredScreen);
    const firstMove = useRef(true);

    useEffect(() => {

        if (moveReceive.current) {
            moveReceive.current = false;
            return;
        }

        const overlayStore = useOverlayStore.getState();
        const screeStore = useScreenStore.getState();
        const screen = screeStore.screen;

        if(screen !== 'Home' && screen !== 'Filtros'){
            overlayStore.closeOverlay();
            return;
        }

        if(firstMove.current){
            firstMove.current = false;
            return;
        }

        const monitorMode = screeStore.monitorMode;

        if (monitorMode !== 2) {
            if (preferredScreen !== 'Home') {
                useOverlayStore
                    .getState()
                    .setPreferredScreen('Home');
            }
            return;
        }

        const overlay = overlayStore.overlay;

        if (!overlay.open) {
            return;
        }

        if (preferredScreen === screen) {
            return;
        }

        const stateExporters = {
            occurrence: () =>
                useOccurrenceModalStore.getState().exportState(),

            calendar: () =>
                useCalendarModalStore.getState().exportState(),

            vehicleConflicts: () =>
                useVehicleConflictStore.getState().exportState(),

            deleteTrip: () =>
                useDeleteTripModalStore.getState().exportState()

        };

        const overlayStateMap = {
            occurrence: [
                'occurrence'
            ],

            calendar: [
                'calendar',
                'vehicleConflicts'
            ],

            delete_trip: [
                'deleteTrip'
            ],
        };

        const state = {};

        const keys =
            overlayStateMap[
                overlay.type
            ] ?? [];

        keys.forEach(key => {
            state[key] =
                stateExporters[key]();
        });

        channel.postMessage({
            tipo: 'overlay:move',
            payload: {
                sourceScreen: screen,
                preferredScreen,
                overlay,
                state
            }
        });  

    }, [preferredScreen]);

    //move
    useEffect(() => {

        const handleMoveMessage = ({ data }) => {

            const screeStore = useScreenStore.getState();
            const screen = screeStore.screen;

            if(screen !== 'Home' && screen !== 'Filtros'){
                return;
            }

            if (data?.tipo !== 'overlay:move' || !data?.payload?.preferredScreen) {
                return;
            }

            if (data.payload.sourceScreen === screen) {
                return;
            }

            if (data.payload.preferredScreen !== screen) {
                return;
            }
            
            moveReceive.current = true;
            
            useOverlayStore.getState().applyMove(
                data.payload.preferredScreen,
                data.payload.overlay
            );

            const state = data?.payload?.state;

            const stateImporters = {
                occurrence: value =>
                    useOccurrenceModalStore.getState().importState(value),

                calendar: value =>
                    useCalendarModalStore.getState().importState(value),

                vehicleConflicts: value =>
                    useVehicleConflictStore.getState().importState(value),

                deleteTrip: value =>
                    useDeleteTripModalStore.getState().importState(value)
            };

            if (state) {
                Object.entries(state).forEach(([key, value]) => {
                    stateImporters[key]?.(value);
                });
            }

        };

        channel.addEventListener('message', handleMoveMessage);

        return () => {

            channel.removeEventListener('message', handleMoveMessage);

        };

    }, []);

    
    //sync
    const syncReceive = useRef(false);
    const firstSync = useRef(true);
    const overlay = useOverlayStore(state => state.overlay);
    useEffect(() => {

        if (syncReceive.current) {
            syncReceive.current = false;
            return;
        }

        const overlayStore = useOverlayStore.getState();
        const screeStore = useScreenStore.getState();
        const screen = screeStore.screen;

        if(screen !== 'Home' && screen !== 'Filtros'){
            return;
        }

        if(firstSync.current){
            firstSync.current = false;
            return;
        }

        channel.postMessage({
            tipo: 'overlay:sync',
            payload: {
                sourceScreen: screen,
                open: overlay.open,
                overlay: overlayStore.overlay
            }
        });

    }, [overlay.open]);

    //sync
    useEffect(() => {

        const handleSyncMessage = ({ data }) => {

            const screeStore = useScreenStore.getState();
            const screen = screeStore.screen;

            if(screen !== 'Home' && screen !== 'Filtros'){
                return;
            }

            if (data?.tipo !== 'overlay:sync') {
                return;
            }

            if (data.payload.sourceScreen === screen) {
                return;
            }

            syncReceive.current = true;

            const { syncOverlay } = useOverlayStore.getState();
            syncOverlay(data.payload.open, data.payload.overlay);

        };

        channel.addEventListener('message', handleSyncMessage);

        return () => {

            channel.removeEventListener('message', handleSyncMessage);

        };

    }, []);

}